import { Timestamp } from "firebase/firestore";
import { TopicType } from "./SKArtifact";
import { ContentAgeRestriction } from "../api/enums";

// export enum TopicType {
//     entertainment = "entertainment",
//     food_and_drink = "food and drink",
//     travel = "travel",
//     music = "music",
//     fashion = "fashion",
//     health_and_fitness = "health and fitness",
//     technology = "technology",
//     sports = "sports",
//     culture = "culture",
//     shopping = "shopping",
//     kids_and_family = "kids and family",
//     business = "business",
//     environment = "environment",
//     education = "education",
//     finance = "finance",
//     books = "books",
//     design = "design",
//   }


  // export enum Tier {
  //   channelUsesPlusSubscription = "channelUsesPlusSubscription",
  //   channelSubscription = "channelSubscription",
  // }

  export enum Tier {
    free = "Free",
    paid = "Paid",
    freeNpaid = "Free and Paid"
  }
  export enum ChannelType {
    brand = "brandChannel",
    creator = "creatorChannel",
  }
  

  export enum ChannelState {
    IN_REVIEW = "IN_REVIEW",
    APPROVED = "APPROVED",
    ACTIVE = "ACTIVE",
    DRAFT = "DRAFT",
  }

  export enum ChannelSubstate {
    NONE = "NONE",
    EDIT_IN_DRAFT = "EDIT_IN_DRAFT",
    EDIT_IN_REVIEW = "EDIT_IN_REVIEW",
    EDIT_REJECTED = "EDIT_REJECTED",
    EDIT_APPROVED = "EDIT_APPROVED",
    WITHDRAWN = "WITHDRAWN",
    REJECTED = "REJECTED",
    DEACTIVATED = "DEACTIVATED",
  }



  export const ChannnelStateToSubstateMap: Record<ChannelState, ChannelSubstate[]> = {
    [ChannelState.IN_REVIEW]: [ChannelSubstate.NONE],
    [ChannelState.ACTIVE]: [
      ChannelSubstate.NONE,
      ChannelSubstate.EDIT_IN_DRAFT,
      ChannelSubstate.EDIT_IN_REVIEW,
      ChannelSubstate.EDIT_REJECTED,
      ChannelSubstate.EDIT_APPROVED,
    ],
    [ChannelState.APPROVED]: [ChannelSubstate.NONE],
    [ChannelState.DRAFT]: [ChannelSubstate.NONE, ChannelSubstate.WITHDRAWN, ChannelSubstate.REJECTED],
  };


  // enum ActionItem {
  //   pre_approve = "Pre Approve",
  //   duplicate = "Duplicate",
  //   delete = "Delete",
  //   withdraw = "Withdraw",
  //   move_to_free = "Move to Free",
  //   move_to_subscription = "Move to Subscription",
  //   submit_for_review = "Submit for Review",
  //   unpublish = "Unpublish",
  //   publish = "Publish",
  //   approve = "Approve",
  //   do_not_approve = "Do not Approve",
  //   block = "Block",
  //   suspend = "Suspend",
  //   remove_suspension = "Remove Suspension",
  //   remove_block = "Remove Block",
  //   keep_published = "Keep Published",
  //   active = "Make Active",
  //   keep_active = "Keep Active",
  //   edit = "Edit",
  //   remove = "Remove",
  //   make_inactive = "Make Inactive"
  // }

  export enum ChannelActionType {
    review = "In Review",
    edit_review = "Edit Review",
    active = "Active",
    withdrawn = "Withdrawn",
    rejected = "Rejected",
    flagged = "Flagged",
  }

  export enum ActionItem {
    duplicate = "Duplicate",
    delete = "Delete Channel",
    withdraw = "Withdraw Channel",
    submit_for_review = "Submit for Review",
    approve = "Approve Channel",
    reject = "Reject Channel",
    reject_edit = "Reject Edits",
    approve_edit = "Approve Edits",
    edit = "Edit Channel Details",
    edit_submit = "Edit & Submit",
    deactive = "Deactivate Channel",
    review_in_progress = "Review in Progress",
    keep_published = "Continue Published"
  }

  export interface ActionOnItem {
    itemid: string;
    action: ActionItem;
  }

  const AdminStateActions: {
    [key in ChannelState]?: {
      [key in ChannelSubstate]?: ActionItem[];
    };
  } = {
    [ChannelState.IN_REVIEW]: {
      [ChannelSubstate.NONE]: [
        ActionItem.approve,
        ActionItem.reject,
      ],
    },
    [ChannelState.ACTIVE]: {
      [ChannelSubstate.NONE]: [
        ActionItem.reject,
      ],
      [ChannelSubstate.EDIT_IN_REVIEW]: [
        ActionItem.reject,
      ],
      [ChannelSubstate.EDIT_REJECTED]: [
        ActionItem.reject,
      ],
      [ChannelSubstate.EDIT_IN_DRAFT]: [
        ActionItem.reject,
      ],
      [ChannelSubstate.EDIT_APPROVED]: [
        ActionItem.reject,
      ],
    },
    [ChannelState.DRAFT]: {
      [ChannelSubstate.REJECTED]: [
        ActionItem.delete,
      ],
      [ChannelSubstate.WITHDRAWN]: [
        ActionItem.delete,
      ],
    },
  };

  export const AdminStateEditActions: {
    [key in ChannelState]?: {
      [key in ChannelSubstate]?: ActionItem[];
    };
  } = {
    [ChannelState.ACTIVE]: {
      [ChannelSubstate.EDIT_IN_REVIEW]: [
        ActionItem.reject_edit,
        ActionItem.approve_edit,

      ]
    },
  };

  export const CreatorStateActions: {
    [key in ChannelState]?: {
      [key in ChannelSubstate]?: ActionItem[];
    };
  } = {
    [ChannelState.IN_REVIEW]: {
      [ChannelSubstate.NONE]: [ActionItem.review_in_progress]
    },
    [ChannelState.ACTIVE]: {
      [ChannelSubstate.NONE]: [
        ActionItem.withdraw,
      ],
      [ChannelSubstate.EDIT_IN_REVIEW]: [
        ActionItem.withdraw,
      ],
      [ChannelSubstate.EDIT_REJECTED]: [
        ActionItem.withdraw,
      ],
      [ChannelSubstate.EDIT_APPROVED]: [
        ActionItem.withdraw,
      ],
    },
    [ChannelState.DRAFT]: {
      [ChannelSubstate.REJECTED]: [
        ActionItem.delete,
      ],
      [ChannelSubstate.WITHDRAWN]: [
        ActionItem.delete,
      ],
    },
  };

  export const CreatorStateEditActions: {
    [key in ChannelState]?: {
      [key in ChannelSubstate]?: ActionItem[];
    };
  } = {
    [ChannelState.ACTIVE]: {
      [ChannelSubstate.EDIT_IN_DRAFT]: [
        ActionItem.withdraw,
      ],
      [ChannelSubstate.EDIT_IN_REVIEW]: [
        ActionItem.withdraw,
      ],
      [ChannelSubstate.EDIT_REJECTED]: [
        ActionItem.withdraw,
      ],
    }
  };


  export function getAdminActionableItems(mixedState: { state: ChannelState; subState: ChannelSubstate }): ActionItem[] {
    const { state, subState } = mixedState;
  
    // Find actions for the given state and substate
    const stateActions = AdminStateActions[state];
    if (!stateActions) return [];
  
    const substateActions = stateActions[subState];
    return substateActions || [];
  }

  export function getAdminActionableEditItems(mixedState: { state: ChannelState; subState: ChannelSubstate }): ActionItem[] {
    const { state, subState } = mixedState;
  
    // Find actions for the given state and substate
    const stateActions = AdminStateEditActions[state];
    if (!stateActions) return [];
  
    const substateActions = stateActions[subState];
    return substateActions || [];
  }

  export function getCreatorActionableItems(mixedState: { state: ChannelState; subState: ChannelSubstate }): ActionItem[] {
    const { state, subState } = mixedState;
  
    // Find actions for the given state and substate
    const stateActions = CreatorStateActions[state];
    if (!stateActions) return [];
  
    const substateActions = stateActions[subState];
    return substateActions || [];
  }

  export function getCreatorActionableEditItems(mixedState: { state: ChannelState; subState: ChannelSubstate }): ActionItem[] {
    const { state, subState } = mixedState;
  
    // Find actions for the given state and substate
    const stateActions = CreatorStateEditActions[state];
    if (!stateActions) return [];
  
    const substateActions = stateActions[subState];
    return substateActions || [];
  }


  const actionToStateMap: {
    [key in ActionItem]?: { state: ChannelState; substate: ChannelSubstate }[];
  } = {
    [ActionItem.approve]: [
      { state: ChannelState.ACTIVE, substate: ChannelSubstate.NONE },
    ],
    [ActionItem.reject]: [
      { state: ChannelState.DRAFT, substate: ChannelSubstate.REJECTED },
    ],
    [ActionItem.withdraw]: [
      { state: ChannelState.DRAFT, substate: ChannelSubstate.WITHDRAWN },
    ],
    [ActionItem.approve_edit]: [
      { state: ChannelState.ACTIVE, substate: ChannelSubstate.EDIT_APPROVED },
    ],
    [ActionItem.reject_edit]: [
      { state: ChannelState.ACTIVE, substate: ChannelSubstate.EDIT_REJECTED },
    ],
    [ActionItem.edit]: [
      { state: ChannelState.ACTIVE, substate: ChannelSubstate.EDIT_IN_DRAFT },
    ],
    [ActionItem.edit_submit]: [
      { state: ChannelState.ACTIVE, substate: ChannelSubstate.EDIT_IN_REVIEW },
    ],
    [ActionItem.submit_for_review]: [
      { state: ChannelState.IN_REVIEW, substate: ChannelSubstate.NONE },
    ],
    [ActionItem.duplicate]: [
      { state: ChannelState.DRAFT, substate: ChannelSubstate.NONE },
    ],
  };

  export function getStatesForAction(actionItem: ActionItem): { state: ChannelState; substate: ChannelSubstate }[] {
  
    // Return the states and substates for the given action item or an empty array if none are found
    return actionToStateMap[actionItem] || [];
  }
  
  export function getActionForStateAndSubState(
    state: ChannelState,
    substate: ChannelSubstate
  ): ActionItem[] {

    const matchingActions: ActionItem[] = [];
  
    // Iterate through the actionToStateMap to find matches
    for (const [action, mappings] of Object.entries(actionToStateMap)) {
      if (mappings) {
        for (const mapping of mappings) {
          if (mapping.state === state && mapping.substate === substate) {
            matchingActions.push(action as ActionItem);
          }
        }
      }
    }
  
    // Return the list of matching actions
    return matchingActions;
  }


  function isValidSubstate(state: ChannelState, substate: ChannelSubstate): boolean {
    return ChannnelStateToSubstateMap[state]?.includes(substate) ?? false;
  }

  export function changeChannelState(
    channel: { state: ChannelState; substate: ChannelSubstate },
    newState: ChannelState,
    newSubstate: ChannelSubstate
  ): { state: ChannelState; substate: ChannelSubstate } {
    if (!isValidSubstate(newState, newSubstate)) {
      throw new Error(`Invalid substate ${newSubstate} for state ${newState}`);
    }
  
    return { ...channel,  state: newState, substate: newSubstate };
  }
  export const getChannelStatusString = (status?: ChannelState, subStatus?: ChannelSubstate, isEdit: boolean = false): string => {

      switch (status) {
        case ChannelState.ACTIVE :
          if(isEdit){
            switch (subStatus) {
              case ChannelSubstate.EDIT_APPROVED:
                return "Edits Approved"
              case ChannelSubstate.EDIT_IN_DRAFT:
                return "Edits in Draft"
              case ChannelSubstate.EDIT_IN_REVIEW:
                return "Edits in Review"
              case ChannelSubstate.EDIT_REJECTED:
                return "Edits Rejected"
              default:
                return "Active"
            } 
          }else{
            return "Active"
          }
        case ChannelState.DRAFT :
         
          switch (subStatus) {
            case ChannelSubstate.NONE:
              return "Draft"
            case ChannelSubstate.REJECTED:
              return "Rejected"
            case ChannelSubstate.WITHDRAWN:
              return "Withdrawn"
            default:
              return ""
          }
        
        case ChannelState.IN_REVIEW :
          return "In Review"

        default:
         return "Status Not found"
    
      }
  }

  export const getChannelHistoryStatusString = (status: ChannelState, subStatus: ChannelSubstate, isEdit: boolean = false): string => {

    switch (status) {
      case ChannelState.ACTIVE :
        if(isEdit){
          switch (subStatus) {
            case ChannelSubstate.EDIT_APPROVED:
              return "Edits Approved"
            case ChannelSubstate.EDIT_IN_DRAFT:
              return "Edits in Draft"
            case ChannelSubstate.EDIT_IN_REVIEW:
              return "Edits in Review"
            case ChannelSubstate.EDIT_REJECTED:
              return "Edits Rejected"
            default:
              return "Active"
          } 
        }else{
          return "Active"
        }
      case ChannelState.APPROVED :
         return "Approved"
      case ChannelState.DRAFT :
       
        switch (subStatus) {
          case ChannelSubstate.NONE:
            return "Draft"
          case ChannelSubstate.REJECTED:
            return "Rejected"
          case ChannelSubstate.WITHDRAWN:
            return "Withdrawn"
          default:
            return ""
        }
      
      case ChannelState.IN_REVIEW :
        return "In Review"
  
    }
}

  export const getChannelEditStatusString = ( subStatus: ChannelSubstate): string => {
    switch (subStatus) {
        case ChannelSubstate.EDIT_APPROVED:
          return "Edits Approved"
        case ChannelSubstate.EDIT_IN_DRAFT:
          return "Edits in Draft"
        case ChannelSubstate.EDIT_IN_REVIEW:
          return "Edits in Review"
        case ChannelSubstate.EDIT_REJECTED:
          return "Edits Rejected"
        default:
          return "Moderator Action"
    } 
  }

  export enum State {
    approved = "approved",
    draft = "draft",
    published = "published",
    need_more_info = "need_more_info",
    rejected = "rejected",
    review = "review",
    blocked = "blocked",
    suspended = "suspended",
    pre_approved = "pre_approved"
  }

  export interface ExternalLink {
    type:string;
    value:string;
  }

  export interface SKChannelReport {
    reportId: string;
    reportedDate?: Timestamp;
    type?: string;
    message?: string;
    channelID: string,
    userID?: string
    phone?: string;
    osType: string;
    osVersion?: string;
    appVersion?: string;
  }
export interface SKChannel {
    id?: string;
    name?: string;
    description?: string;
    profileImageUrl?: string;
    backgroundImageUrl?: string;
    promoMediaURL?: string;
    language?: string;
    secondLanguage?: string;
    country?: string;
    externalLinks: ExternalLink[] | null;
    topic: TopicType | null;
    age?: ContentAgeRestriction;
    status: ChannelState;
    subStatus: ChannelSubstate;
    certifyFirst?: boolean;
    certifySecond?: boolean;
    subscriptionStatus?: Tier;
    expectedMonthlySubscriptionPrice?: string;
    expectedYearlySubscriptionPrice?: string;
    adjustSubscriptionPriceByCountry?:boolean;
    appleMonthlySubscriptionId? : string;
    appleYearlySubscriptionId? : string;
    googleSubscriptionGroup?: string;
    googleMonthlySubscriptionId? : string;
    googleYearlySubscriptionId? : string;
    subscriptionImageUrl? : string;
    subscriptionVideoUrl? : string;
    autoPublish?: boolean;
    createdDate?: Timestamp;
    reason?:string;
    flagged?: boolean
    userId?:string
    channelType?: ChannelType
    editUpdateDate?: Timestamp;
    followerCount?: number;
    subscriberCount?: number;
    reportCount?: number;
    lastReportedDate?: Timestamp;
    lastActivityDate?: Timestamp;
}


export interface SKChannelStatusHistory{
  createdDate: Timestamp;
  status: State;
  reason?: string;
  note?: string;
}


